module.exports = __webpack_public_path__ + "img/f70fd54244b235ad46e3c904078ad098.png";